import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tradesService } from '@/services/trades/trades-service';
import { tradesKeys } from '@/services/query-keys/trades-keys';

/**
 * LR-715: close a posting BackOffice contradicted itself about, on the operator's
 * authority.
 *
 * Invalidates the whole trades key like its siblings, and here the refresh IS the
 * visible result: the settled row leaves `UNRESOLVED_FAILURE_STATES`, so the trade
 * page's panel and the blotter's stuck-posting accent both go away. A stale row
 * would leave the trade shouting about a problem that was just closed — which is
 * the exact stall this action exists to end.
 */
export const useSettleBoPostingManually = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, reason }: { id: number; reason: string }) =>
      tradesService.settleBoPostingManually(id, reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tradesKeys.all });
    },
  });
};
